import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class EmailContentAndSubject {
  @IsString()
  @Expose()
  subject!: string;
  @IsString()
  @Expose()
  content!: string;
}
